import { render, staticRenderFns } from "./BugCommitAttachment.vue?vue&type=template&id=13c801a4&scoped=true&"
import script from "./BugCommitAttachment.vue?vue&type=script&lang=js&"
export * from "./BugCommitAttachment.vue?vue&type=script&lang=js&"
import style0 from "./BugCommitAttachment.vue?vue&type=style&index=0&id=13c801a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c801a4",
  null
  
)

export default component.exports